import discipline from '../assets/discipline.svg'
import productMgmt from '../assets/productmgmt.svg'
import devlop from '../assets/devlop.svg'
import strategy from '../assets/strategy.svg'

const AreaData = [
    {
        id: 1,
        title: "Multi-Discipline Design",
        img: discipline,
        desc: "Our team of designers has immense knowledge & skills and work together for effectively solving even the most complex designing problems."
    },
    {
        id: 2,
        title: "Product Management",
        img: productMgmt,
        desc: "Our talented project managers have the skills to efficiently manage the designing process and provide feasible suggestions that help us to overcome any difficulty."
    },
    {
        id: 3,
        title: "Design & Development",
        img: devlop,
        desc: "Our design and development team has excellent experience and is always ready to step in for challenges to successfully stand on the requirements of our clients."
    },
    {
        id: 4,
        title: "Business Strategy",
        img: strategy,
        desc: "We have a customer-centric business strategy that has helped us to build websites that fetches good quality & quantity of leads for your business."
    }
]

export default AreaData